// extracted by mini-css-extract-plugin
module.exports = {"gameForm":"GameForm_gameForm__1wDL4","btn":"GameForm_btn__xitqo","box_1":"GameForm_box_1__2_M_O"};